import { Component, ChangeDetectionStrategy, Input } from '@angular/core';
import { AbstractGatewayService } from '../../services/abstract-gateway.service';
import { MarketingEmailBlockerViewModel } from './marketing-email-blocker.view-model';

@Component({
  selector: 'osn-shared-marketing-email-blocker',
  templateUrl: './marketing-email-blocker.component.html',
  styleUrls: ['./marketing-email-blocker.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class MarketingEmailBlockerComponent {
  @Input() public vm: MarketingEmailBlockerViewModel;
  @Input() public minHeight?: string;

  constructor(private readonly gatewayService: AbstractGatewayService) {}

  public signIn() {
    // TODO GTM
    this.gatewayService.login();
  }
}
